import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles()((theme) => ({
  list: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  row: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 2fr) minmax(0, 3fr) 34px",
    gap: theme.spacing(1),
    alignItems: "center",
  },
}));

let rowSequence = 0;
const newRow = (name = "", value = "") => {
  rowSequence += 1;
  return { id: rowSequence, name, value, visible: !value };
};

const rowsToHeaders = (rows) =>
  rows.reduce((headers, row) => {
    const name = row.name.trim();
    if (name) headers[name] = row.value.trim();
    return headers;
  }, {});

const ToolHeadersEditor = ({ value, onChange }) => {
  const { classes } = useStyles();
  const [rows, setRows] = useState(() => Object.entries(value || {}).map(([name, val]) => newRow(name, val)));

  const commit = (next) => {
    setRows(next);
    onChange(rowsToHeaders(next));
  };

  const update = (id, changes) => commit(rows.map((row) => (row.id === id ? { ...row, ...changes } : row)));

  return (
    <div className={classes.list}>
      {rows.map((row) => (
        <div key={row.id} className={classes.row}>
          <TextField
            size="small"
            placeholder={i18n.t("promptModal.form.herramientas.headerName")}
            value={row.name}
            onChange={(e) => update(row.id, { name: e.target.value })}
          />
          <TextField
            size="small"
            placeholder={i18n.t("promptModal.form.herramientas.headerValue")}
            type={row.visible ? "text" : "password"}
            value={row.value}
            onChange={(e) => update(row.id, { value: e.target.value })}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setRows(rows.map((r) => (r.id === row.id ? { ...r, visible: !r.visible } : r)))}>
                      {row.visible ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
          <IconButton size="small" onClick={() => commit(rows.filter((r) => r.id !== row.id))}>
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </div>
      ))}
      <Button
        size="small"
        startIcon={<AddOutlinedIcon />}
        style={{ alignSelf: "flex-start" }}
        onClick={() => setRows([...rows, newRow()])}
      >
        {i18n.t("promptModal.form.herramientas.addHeader")}
      </Button>
    </div>
  );
};

export default ToolHeadersEditor;
